export default [
  {
    name: 'Product',
    prop: 'product_id',
    type: 'autocomplete',
    references: 'admin/products',
    referenceProp: 'name'
  },
  {
    name: 'Discount',
    prop: 'discount_id',
    type: 'autocomplete',
    references: 'admin/discounts',
    referenceProp: 'code'
  }
]
